let styles = {
  container: {
    textTransform: 'uppercase',
    fontSize: '12px',
    color: '#616161',
  },
  crumb: {
    display: 'inline',
  },
  divider: {
    display: 'inline',
    marginLeft: '.5em',
    marginRight: '.5em',
  },
  currentLocation: {
    display: 'inline',
  }
};

export default styles;
